var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencyServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26.471H25v-3.5a1 1 0 0 0-2 0v3.5h-3.5a1 1 0 0 0 0 2H23v3.5a1 1 0 0 0 2 0v-3.5h3.5a1 1 0 0 0 0-2zM24 14.751a2.012 2.012 0 0 0-1.98 1.72h3.96a2.012 2.012 0 0 0-1.98-1.72z",
    fill: "#EE2522",
    opacity: 1,
    "data-original": "#EE2522",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 6H11a5 5 0 0 0-5 5v26a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5zM20.01 16.471a4.003 4.003 0 0 1 7.98 0 1 1 0 0 1 .01 2h-8a1 1 0 0 1 .01-2zM34.287 33.21a2 2 0 0 1-2 2H15.713a2 2 0 0 1-2-2V21.733a2 2 0 0 1 2-2h16.574a2 2 0 0 1 2 2z",
    fill: "#EE2522",
    opacity: 1,
    "data-original": "#EE2522",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyServices);
export default __webpack_public_path__ + "static/media/emergency_services.473aa2953b6a17d1db7b5c951ded8469.svg";
export { ForwardRef as ReactComponent };